module.exports = __webpack_public_path__ + "img/home-personas-3.9798967.webp";